import { render, staticRenderFns } from "./gdColdBoard.vue?vue&type=template&id=773cf458&scoped=true"
import script from "./gdColdBoard.vue?vue&type=script&lang=js"
export * from "./gdColdBoard.vue?vue&type=script&lang=js"
import style0 from "./gdColdBoard.vue?vue&type=style&index=0&id=773cf458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773cf458",
  null
  
)

export default component.exports